// extracted by mini-css-extract-plugin
export var breadcrumbsContainer = "p_n";
export var ctasSection = "p_bd";
export var defaultBackground = "p_bk";
export var heroBackground = "p_bb";
export var heroContainer = "p_bc";
export var heroHeadline = "p_bh";
export var imageSection = "p_bf";
export var subTitleSection = "p_bj";
export var textSection = "p_bg";